export const getMockedResponse = (decodedBody: Record<string, any> | string | undefined | null | Blob, status: number, error?: {message: string; code?: string;}) => {
    let data = decodedBody;
    const additional: Record<string, any> = {};
    if (typeof decodedBody === 'string') {
        additional['headers'] = {
            'Content-Type': 'text/plain'
        }
    } else if (decodedBody instanceof Blob) {
        additional['headers'] = {
            'Content-Type': decodedBody.type || 'image/png',
            'Content-Length': decodedBody.size
        }
    } else if (decodedBody && typeof decodedBody === 'object') {
        data = JSON.stringify(decodedBody, null, 2);
        additional['headers'] = {
            'Content-Type': 'application/json'
        }
    }
    if (status < 200 || status >= 300) {
        // While 300 && < 400 isn't failure, it isn't something we will be expecting
        return new Response(
            JSON.stringify({
                error: error?.message || 'An unexpected error occurred',
                code: error?.code || 'UNEXPECTED_ERROR'
            }),
            {
                status,
                headers: { 'Content-Type': 'application/json' }
            }
        );
    }
    return new Response(data as BodyInit | null | undefined, {
        ...additional,
        status,
        statusText: 'success'
    });
}

export const deepJsonCopy = (data: any) => JSON.parse(JSON.stringify(data));

export const MOCK_TIMEOUT_WAIT = 300;
export const MOCK_TIMEOUT_TEST = 400;
